import { render, staticRenderFns } from "./RecipePriceUpdateForm.vue?vue&type=template&id=241456a6&scoped=true"
import script from "./RecipePriceUpdateForm.vue?vue&type=script&lang=js"
export * from "./RecipePriceUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./RecipePriceUpdateForm.vue?vue&type=style&index=0&id=241456a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241456a6",
  null
  
)

export default component.exports